import { useContext } from 'react';
import { PageContext } from '@sleepunique/context/PageContext';

import { PageId } from '@sleepunique/types/view-id-type';

const usePreviousStepOverride = (
  previousPageId: PageId,
  setSleeper: number,
  questionName: string,
  override = false
) => {
  const { setBackPage } = useContext(PageContext);

  const goBack = { override, backPageId: previousPageId, questionName, newSleeperId: setSleeper };

  return () => {
    if (typeof setBackPage === 'undefined') return;

    setBackPage(goBack);
  };
};

export default usePreviousStepOverride;
